import {Component} from "@angular/core";
@Component({
  template: `
        <div class="big-classroom">
       
        <div class="middle-box"><br>
        <h2>蒞店花絮</h2><h3></h3>
        <div class="line-classroom"></div><br>
        <p><span class="text">[工欲善其事 必先利其器]</span></p>
        <p>選手與教練裝備補給的最佳選擇，提供專業水準的器材品質與建議</p>
        <p>不定期活動拉近球友與選手的距離</p><br>
        <p>(特此感謝蒞店參訪之貴賓)</p><br>
        
        </div></div>
        
        <div class="container">
        <div class="title-special">
        <div class="title-special-line"></div>貴賓蒞臨參訪<div class="title-special-line2"></div>       
        </div> 
        <div class="classroomImgDiv">
        <div class="classroom-img">
        <img src="../../img/classroom/250813.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/250802.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/250720.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> <div class="classroom-img">
        <img src="../../img/classroom/250216.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/250215.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/250126.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/241227.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/241220.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/241020.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/240602.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/231207.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/231122.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/2312066.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/2312065.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/2312064.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/2312063.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/2312062.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/2312061.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/221110.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/221022.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/221010.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/2209306.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/2209305.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/2209304.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/2209303.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/2209302.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/2209301.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/210408.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/211009.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/211011.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/201121.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/201023.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/201016.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div> 
        <div class="classroom-img">
        <img src="../../img/classroom/200917.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200913.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200831.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200830.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200827.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200822.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200813.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200804.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200801.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200730.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200522.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200415.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200328.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200321.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200215.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200120.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/200113.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/191225.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/191220.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/191127.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/191103.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/190822.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/190718.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/190707.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/190627.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/190511.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
        <div class="classroom-img">
        <img src="../../img/classroom/190423.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
        </div>
       
       
        </div>

        
        <div class="title-special">
        <div class="title-special-line"></div>活動花絮<div class="title-special-line2"></div>       
        </div>

        
        <div class="classroom-last-text">        
        <p>

        <span class="text"><p>【2020/11/21 陳建安 “一日店長”快閃活動 】<br></p></span>
        
        <img src="../../img/classroom/51.jpg" width="240px" height="180px">
        <img src="../../img/classroom/52.jpg" width="240px" height="180px">
        <img src="../../img/classroom/53.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
     
        <span class="text"><p>【2019/01/06 鄭先知簽名握手會 】<br></p></span>
        <a href="https://www.facebook.com/Bolltabletennisshop/photos/?tab=album&album_id=2008109079304644" target="_blank">我和🏓桌球女神「鄭先知」有個約會2019</a> <br>
        
        <img src="../../img/classroom/43.jpg" width="240px" height="180px">
        <img src="../../img/classroom/44.jpg" width="240px" height="180px">
        <img src="../../img/classroom/45.jpg" width="240px" height="180px">
        <span class="text"><p></p></span>
     
        <span class="text"><p>【2019/06/22 台灣一姐-鄭怡靜粉絲見面會 】<br></p></span>
        <a href="https://www.facebook.com/Bolltabletennisshop/photos/?tab=album&album_id=2253635241418692" target="_blank">「怡靜」與台灣桌球粉絲的美麗見面會</a> <br>
        <br>
        <iframe width="702" height="395" src="https://www.youtube.com/embed/d7eGYwxxt24" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </p>
        </div>
        </div>
        
    `,
})

export class ClassroomComponent {

}



// WEBPACK FOOTER //
// ./src/app/Classroom/classroom.component.ts